import { useRouter } from 'next/router'
import { useMarket } from './useMarket'

/**
 * Hook to check if new filters should be enabled
 * New filters are enabled only for:
 * - IE market (Ireland)
 * - When the URL has the feature flag: ?ff=new_filters
 */
export const useNewFilters = () => {
  const { query } = useRouter()
  const { market } = useMarket()

  const hasFeatureFlag = query.ff?.includes('new_filters')
  const isIEMarket = market?.toLowerCase() === 'ie'

  return {
    hasNewFilters: hasFeatureFlag || isIEMarket,
    hasExtendedFilters: query.ff?.includes('extended_filters'),
  }
}
